export function getLabelColor(category) {
  switch (category) {
    case 'MedBlitz':
      return 'label_color_purple';
    case 'MedCuts':
      return 'label_color_green';
    case 'Interview':
      return 'label_color_red';
    case 'MedShare':
      return 'label_color_turquoise';
    case 'MedTech':
      return 'label_color_blue';
    default:
      return 'label_color_blue';
  }
}
